import { render } from "./Tag.vue?vue&type=template&id=09975864"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09975864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09975864', __exports__)) {
    api.reload('09975864', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=09975864", () => {
    api.rerender('09975864', render)
  })

}


export default __exports__